export default "__VITE_ASSET__BJPC2V5T__"